module.exports = __webpack_public_path__ + "static/media/instagram.67702b5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram.svg
// module id = 1993
// module chunks = 0